import * as React from "react";
import { ViewModal } from "../../../components/modals/viewModal";
import { store } from "../../../store";
import { formSet, useCpFormAnyValue, useCpFormValue } from "../../gvc/testNewForm/utils";
import { useCpFormContext } from "../../../components/form/useCpFormContext";

interface Props {
  title: string;
  kind: string;
  namePath: string;
  inputToItemFn: any;
}
export const CpPreviewModal: React.FC<Props> = ({ title, kind, namePath, inputToItemFn }) => {
  const { id } = useCpFormContext();
  const isPreviewing = useCpFormAnyValue(`meta.previewing`);
  const name = useCpFormValue(namePath);

  if (!isPreviewing) {
    return null;
  }

  return (
    <ViewModal
      kind={"kind"}
      onClose={() => formSet(id, `meta.previewing`, false)}
      title={title}
      object={() => {
        try {
          const form = store.getState().form.instances[id];
          const values = form.values;
          const object = inputToItemFn(values);
          return object;
        } catch (e) {
          return { error: e.message };
        }
      }}
      visible={isPreviewing}
      filename={`${kind}-${name}`}
    />
  );
};
